export const formatRupiah = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "Rp 0";
  const num = Math.round(Number(n));
  return "Rp " + num.toLocaleString("id-ID");
};

export const formatRupiahDot = (n) => {
  // "Rp. 18.114.000" style for kop surat
  if (n === null || n === undefined || isNaN(n)) return "Rp. 0";
  return "Rp. " + Math.round(Number(n)).toLocaleString("id-ID");
};

export const formatDate = (iso) => {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return d.toLocaleString("id-ID", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

// Map kategori tindakan -> KSM yang relevan untuk dropdown dokter operator
export const KATEGORI_KSM_MAP = {
  Caesaria: ["Spesialis Kebidanan"],
  "Bedah Umum": ["Spesialis Bedah"],
  Kebidanan: ["Spesialis Kebidanan"],
  Mata: ["Spesialis Mata"],
  THT: ["Spesialis THT"],
  ORTHOPEDI: ["Spesialis Orthopedi"],
};

export const ksmForKategori = (kategori) => {
  if (!kategori) return null;
  for (const key of Object.keys(KATEGORI_KSM_MAP)) {
    if (kategori.includes(key)) return KATEGORI_KSM_MAP[key];
  }
  return null;
};

export const isCaesariaCandidate = (kategori) => {
  if (!kategori) return false;
  const k = kategori.toLowerCase();
  return k.includes("kebidanan") || k.includes("caesaria");
};

// e.g. "Tonsilektomi (op khusus), Reduksi Konka (op khusus)"
export const kategoriShortLabel = (kategori) => {
  if (!kategori) return "";
  // kategori format e.g. "Besar Bedah Umum" -> "op besar"
  // or "Khusus 2 ORTHOPEDI" -> "op khusus"
  // or "Caesaria Anak Satu" -> "caesaria"
  const lower = kategori.toLowerCase();
  if (lower.startsWith("caesaria")) return "caesaria";
  if (lower.startsWith("besar")) return "op besar";
  if (lower.startsWith("khusus")) return "op khusus";
  if (lower.startsWith("sedang")) return "op sedang";
  if (lower.startsWith("kecil")) return "op kecil";
  return kategori.toLowerCase();
};
